import { useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";

const CustomTooltip = ({
  id,
  place,
  type = "info",
  className,
  classNameArrow,
  bordered,
  dark,
  children,
  offset,
}) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => tooltipRef.current?.close();
    document.addEventListener("scroll", handleScroll, { capture: true });
    return () =>
      document.removeEventListener("scroll", handleScroll, { capture: true });
  }, []);

  return createPortal(
    <Tooltip
      ref={tooltipRef}
      id={id}
      place={place}
      type={type}
      className={`basic-tooltip ${bordered ? "bordered" : ""} ${dark ? "dark" : ""} ${className || ""}`}
      classNameArrow={classNameArrow}
      offset={offset}
      positionStrategy="fixed"
      delayShow={200}
      delayHide={0}
      closeEvents={{ mouseleave: true, blur: true }}
      globalCloseEvents={{
        escape: true,
        scroll: true,
        resize: true,
        clickOutsideAnchor: true,
      }}
    >
      {children}
    </Tooltip>,
    document.body,
  );
};

export default CustomTooltip;
